import { render, staticRenderFns } from "./AddressCustomerSelector.vue?vue&type=template&id=7a507d30&"
import script from "./AddressCustomerSelector.vue?vue&type=script&lang=js&"
export * from "./AddressCustomerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports